import axios from "axios";

const API = process.env.REACT_APP_BASE_URL;

export const getPublicInsuranceDetails = (id) => {
    return axios.get(`${API}/api/v1/public/insuranceDetails/${id}`);
};

export const addPublicRemark = (id, data) => {
    return axios.post(
        `${API}/api/v1/public/insurance-claim/${id}/remark`,
        data
    );
};